import { cn } from '@/lib/utils';
import { ScreenTitle } from '@/components/ui/Title.tsx';
import { ClientAcceptanceVm } from '@/features/dashboard/bookingChanges/types/ChangePackageFlowViewModel.ts';
import { acceptanceIntroSentence } from './clientAcceptanceCopy.ts';

interface ClientAcceptanceIntroProps
  extends React.HTMLAttributes<HTMLDivElement> {
  view: ClientAcceptanceVm;
}

/** Otwarcie strony klienta: po co dostał link i co znajdzie poniżej. */
const ClientAcceptanceIntro = ({
  view,
  className,
  ...props
}: ClientAcceptanceIntroProps) => (
  <div
    className={cn('@max-[700px]:px-4 px-[26px] pb-5 pt-[26px]', className)}
    {...props}
  >
    <ScreenTitle className="text-pretty">
      Zmiany w rezerwacji czekają na Twoją zgodę
    </ScreenTitle>
    <p className="mt-2 text-pretty text-[15px] leading-relaxed text-neutral-600">
      {acceptanceIntroSentence(view)}
    </p>
  </div>
);

export default ClientAcceptanceIntro;
